import { Flex, Splitter } from 'antd';

import { DirectoryTreeWrapper } from './directory-tree-wrapper';
import { DocumentTable } from './document-table';

export const DocumentsPageLayout = () => {
    return (
        <Flex style={{ height: '100%' }}>
            <Splitter>
                <Splitter.Panel
                    defaultSize="20%"
                    min="10%"
                    max="40%"
                    style={{
                        padding: '8px',
                        borderRight: '1px solid #f0f0f0',
                    }}
                >
                    <DirectoryTreeWrapper />
                </Splitter.Panel>
                <Splitter.Panel
                    style={{
                        padding: '8px 8px 0px 16px',
                    }}
                >
                    <DocumentTable />
                </Splitter.Panel>
            </Splitter>
        </Flex>
    );
};
